import { AjaxService } from 'src/app/shared/ajax.service'
import { Injectable } from '@angular/core'
import { GlobService } from 'src/app/shared/glob.service'

@Injectable({ providedIn: 'root' })
export class AuthService {
    logged: boolean = false
    session: any = null
    profile: any = {name: 'کاربر' , family:'میهمان', user_name: ''}
    menu: any = null
 
    constructor (private glob: GlobService, private ajax: AjaxService){}
    isAuthenticated() {
        return new Promise((resolve, reject) => {
            resolve(this.logged)
        })
    }

    login(data: any, callback: any) {
        this.ajax.execute({
            url: 'session/login',
            data: data,
            type: 'post',
            success: (post: any) => {
                this.logged = true
                this.session = post.result.session
                this.profile = post.result.profile
                this.menu = post.result.menu

                this.glob.profile = this.profile
                this.glob.session = this.session
                if (callback) callback()
            }
        })

    }

    logout(callback: any) {
        this.ajax.execute({
            url: 'session/logout',
            success: (post: any) => {
                this.logged = false
                this.session = null
                this.profile = null
                this.menu = null
                if (callback) callback()
            }
        })
    }

    register(data: any, callback: any) {
        this.ajax.execute({
            url: 'session/register',
            data: data,
            success: (post: any) => {
                if (callback) callback()
            }
        })
    }
}